<template>
  <div class="l-m-box">
    <el-card>
      <el-button
        @click="jump()"
        slot="header"
        size="medium"
        type="primary"
      >{{$t('lang.lab_addLink')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0? require('@/config/enum').tableheight720 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="title" :label="$t('lang.lab_mainQuestion')"></el-table-column>
        <el-table-column :label="$t('lang.lab_link')">
          <template slot-scope="scope">{{ scope.row.link }}</template>
        </el-table-column>
        <el-table-column prop="createTime" sortable :label="$t('lang.lab_postingtime')">
          <template slot-scope="scope">{{ scope.row.createTime | time }}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{modifyname}}</el-button>
            <el-button class="orange" @click="delete1(scope.row.id)">{{deletename}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:linkManagementList
 *@Description:链接管理
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-02
 */
export default {
  data() {
    return {
      pageCount: 1,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      multipleSelection: [], // 多选框
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      deletename: require('@/config/enum').deletename,
      modifyname: require('@/config/enum').modifyname
    }
  },
  created() {    
    setTimeout(() => {
     window.localStorage.setItem('ljform', '')
    }, 200)
    this.list()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 链接管理列表
    list() {
      let loading = this.$loading()
      this.$get(`/links?pageSize=${this.pageSize}&pageNo=${this.pageNum}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.list.length
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    edit(id) {
      this.$router.push({ name: 'addLinkManagement', query: { id: id } })
    },
    commit() {
      this.pageNum = 1
      this.list()
    },
    delete1(id) {
      let loading = this.$loading()
       this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel')
        }
      )
        .then(() => {
          this.$delete(`/links/` + id).then(
            // 统一管理mapi
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    jump() {
      this.$router.push({ name: 'addLinkManagement' })
    }
  }
}
</script>

<style scoped>
.edit,
.delete {
  cursor: pointer;
}
.btn1 {
  float: right;
}
</style>